<mat-toolbar>
    <a class="navbar-brand" routerLink="/dashboard" *ngIf="loginService.currentUser | async">Dashboard</a>
    <div fxFlex="grow"></div>
    <a mat-button (click)="goBack()">Back</a>
    <span *ngIf="loginService.isAuthenticated$ | async">
    <a mat-button (click)="logout()">Logout</a>
  </span>
</mat-toolbar>